(function () {
  const KEY = "tt_client";
  const BLANK_VALUE = "Blank";

  function getClientFromUrl() {
    const params = new URLSearchParams(window.location.search);
    const c = params.get("client");
    return c && c.trim() ? c.trim() : "";
  }

  function setStorage(value) {
    try {
      if (value) sessionStorage.setItem(KEY, value);
      else sessionStorage.removeItem(KEY);
    } catch (e) {}

    try {
      if (value) localStorage.setItem(KEY, value);
      else localStorage.removeItem(KEY);
    } catch (e) {}
  }

  function applyClientToInputs(value) {
    const inputs = document.querySelectorAll("input.tt-client-prop");
    inputs.forEach((inp) => {
      inp.value = value;
    });
  }

  function run() {
    const clientFromUrl = getClientFromUrl();

    // Explicit client beats everything
    if (clientFromUrl) {
      setStorage(clientFromUrl);
      applyClientToInputs(clientFromUrl);
      return;
    }

    // No client context → explicitly mark as Blank
    setStorage(BLANK_VALUE);
    applyClientToInputs(BLANK_VALUE);
  }

  document.addEventListener("DOMContentLoaded", run);
  window.addEventListener("pageshow", run);

  // Enforce right before any add-to-cart submit
  document.addEventListener(
    "submit",
    function (e) {
      const form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!form.querySelector('input[name="id"]')) return;
      run();
    },
    true
  );
})();
